// store/sagas/instantServiceSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchInstantServiceDetailRequest,
  fetchInstantServiceDetailSuccess,
  fetchInstantServiceDetailFailure,
  logInstantServiceActivityRequest,
  logInstantServiceActivitySuccess,
  logInstantServiceActivityFailure,
} from "../slices/instantServiceSlice";

// API calls
const fetchInstantServiceDetailAPI = async (id) => {
  const API_URL = `${process.env.REACT_APP_API_URL}/v1/instant-services/show/${id}`;
  const response = await fetch(API_URL);
  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message || "Failed to fetch service details");
  }

  if (!result.data || !result.data.service) {
    throw new Error("Service details could not be found.");
  }

  return result.data.service;
};

const logInstantServiceActivityAPI = async (payload) => {
  const ACTIVITY_API_URL = `${process.env.REACT_APP_API_URL}/v1/instant-services/activity`;
  const response = await fetch(ACTIVITY_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to log activity");
  }

  return response.json();
};

// Sagas
function* fetchInstantServiceDetailSaga(action) {
  try {
    const { id } = action.payload;
    const service = yield call(fetchInstantServiceDetailAPI, id);

    // Check if service is active
    if (service.status !== "active") {
      yield put(fetchInstantServiceDetailFailure("Service is not active."));
      return;
    }

    yield put(fetchInstantServiceDetailSuccess(service));
  } catch (error) {
    yield put(
      fetchInstantServiceDetailFailure(
        error.message ||
          "An error occurred while fetching the service details.",
      ),
    );
  }
}

function* logInstantServiceActivitySaga(action) {
  try {
    const { id, visitorData } = action.payload;
    const payload = {
      id: parseInt(id),
      ...visitorData,
    };

    yield call(logInstantServiceActivityAPI, payload);
    yield put(logInstantServiceActivitySuccess());
  } catch (error) {
    yield put(logInstantServiceActivityFailure(error.message));
  }
}

// Watcher Sagas
export function* watchInstantServiceDetail() {
  yield takeLatest(
    fetchInstantServiceDetailRequest.type,
    fetchInstantServiceDetailSaga,
  );
}

export function* watchInstantServiceActivity() {
  yield takeLatest(
    logInstantServiceActivityRequest.type,
    logInstantServiceActivitySaga,
  );
}
